import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const updateNotificationsEmail = async (domain: string, email: string | null): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `notifications-email`,
        method: 'POST',
        params: { email },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}